import { download, generateCsv, mkConfig } from "export-to-csv"
import { MRT_Row } from "material-react-table"
import { useDateTime } from "../../../../../localization/useDateTime"
import { useMoney } from "../../../../../currency/useMoney"
import { toDinero } from "../../../../../currency/currencyLib"
import { MerchantSalesMerchants } from "../../merchantSales/merchantSalesTypes"
import { MonetaryAmount } from "../../../../../currency/currencyTypes"

export const useExportCustomerSales = (chosenStartDate: string, chosenEndDate: string) => {
    const dateTimeFactory = useDateTime()
    const moneyFactory = useMoney({})

    const formattedStartDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenStartDate))
    const formattedEndDate = dateTimeFactory.formatDate(dateTimeFactory.fromISO(chosenEndDate))

    const csvOptions = mkConfig({
        fieldSeparator: ";",
        quoteStrings: true,
        decimalSeparator: ".",
        useBom: true,
        useKeysAsHeaders: true,
        filename: `Customer_sales-${formattedStartDate}_${formattedEndDate}`,
    })
    function getAmountString(amount: MonetaryAmount | undefined) {
        if (!amount) return ""
        const dinero = toDinero(amount)
        return moneyFactory.formatAsNumber(dinero)
    }

    const mapCustomerSalesToCsvRow = (data: MerchantSalesMerchants) => ({
        RegNo: data?.caseNumber,
        Name: data?.name,
        Address: data?.address?.displayName,
        "Upcoming Sales": getAmountString(data?.upcomingSales),
        "Booked Sales (DKK)": getAmountString(data?.bookedSales),
    })

    const handleExportRows = (rows?: MRT_Row<MerchantSalesMerchants>[]) => {
        let exportRows = []

        if (rows && rows.length > 0) {
            const rowData = rows.map((row) => row.original)
            exportRows = rowData.map((data) => mapCustomerSalesToCsvRow(data))
        } else {
            exportRows = [mapCustomerSalesToCsvRow({} as MerchantSalesMerchants)]
        }

        const csv = generateCsv(csvOptions)(exportRows)
        download(csvOptions)(csv)
    }

    return { handleExportRows }
}
